import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import { withTranslation } from 'react-i18next';

class Education extends Component {
    render() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <PageHelmet 
                    pageTitle={t('education.pageTitle')}
                    description={t('education.metaDescription')}
                    keywords={t('education.metaKeywords')}
                    siteName={t('common.siteName')}
                />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                {/* Hero Section */}
                <div className="education-hero-area ptb--120 bg_color--1">
                    <div className="container">
                        <div className="section-title text-center mb--50">
                            <h1 className="title">{t('education.heroTitle')}</h1>
                            <h2 className="subtitle">{t('education.heroSubtitle')}</h2>
                            <p className="description">
                                {t('education.heroDesc')}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Activity Showcase */}
                <div className="activity-showcase-area ptb--80 bg_color--2">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb--50">
                                    <h2>{t('education.activityTitle')}</h2>
                                    <p className="description">
                                        {t('education.activityDesc')}
                                    </p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="row">
                            <div className="col-lg-3 col-md-4 col-sm-6 mb--30">
                                <div className="activity-image-card">
                                    <div className="image-wrapper">
                                        <img src="/assets/images/activity/present.jpeg" alt={t('education.activity1')} />
                                    </div>
                                    <div className="activity-title">
                                        <h4>{t('education.activity1')}</h4>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-lg-3 col-md-4 col-sm-6 mb--30">
                                <div className="activity-image-card">
                                    <div className="image-wrapper">
                                        <img src="/assets/images/activity/tree.jpg" alt={t('education.activity2')} />
                                    </div>
                                    <div className="activity-title">
                                        <h4>{t('education.activity2')}</h4>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-lg-3 col-md-4 col-sm-6 mb--30">
                                <div className="activity-image-card">
                                    <div className="image-wrapper">
                                        <img src="/assets/images/activity/tree-walk.jpg" alt={t('education.activity3')} />
                                    </div>
                                    <div className="activity-title">
                                        <h4>{t('education.activity3')}</h4>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-lg-3 col-md-4 col-sm-6 mb--30">
                                <div className="activity-image-card">
                                    <div className="image-wrapper">
                                        <img src="/assets/images/activity/egg.png" alt={t('education.activity4')} />
                                    </div>
                                    <div className="activity-title">
                                        <h4>{t('education.activity4')}</h4>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-lg-3 col-md-4 col-sm-6 mb--30">
                                <div className="activity-image-card">
                                    <div className="image-wrapper">
                                        <img src="/assets/images/activity/cooking.jpg" alt={t('education.activity5')} />
                                    </div>
                                    <div className="activity-title">
                                        <h4>{t('education.activity5')}</h4>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-lg-3 col-md-4 col-sm-6 mb--30">
                                <div className="activity-image-card">
                                    <div className="image-wrapper">
                                        <img src="/assets/images/activity/eating.jpg" alt={t('education.activity6')} />
                                    </div>
                                    <div className="activity-title">
                                        <h4>{t('education.activity6')}</h4>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-lg-3 col-md-4 col-sm-6 mb--30">
                                <div className="activity-image-card">
                                    <div className="image-wrapper">
                                        <img src="/assets/images/activity/paint.jpg" alt={t('education.activity7')} />
                                    </div>
                                    <div className="activity-title">
                                        <h4>{t('education.activity7')}</h4>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-lg-3 col-md-4 col-sm-6 mb--30">
                                <div className="activity-image-card">
                                    <div className="image-wrapper">
                                        <img src="/assets/images/activity/pond.jpg" alt={t('education.activity8')} />
                                    </div>
                                    <div className="activity-title">
                                        <h4>{t('education.activity8')}</h4>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-lg-3 col-md-4 col-sm-6 mb--30">
                                <div className="activity-image-card">
                                    <div className="image-wrapper">
                                        <img src="/assets/images/activity/water.jpg" alt={t('education.activity9')} />
                                    </div>
                                    <div className="activity-title">
                                        <h4>{t('education.activity9')}</h4>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-lg-3 col-md-4 col-sm-6 mb--30">
                                <div className="activity-image-card">
                                    <div className="image-wrapper">
                                        <img src="/assets/images/activity/tree-cup.jpg" alt={t('education.activity10')} />
                                    </div>
                                    <div className="activity-title">
                                        <h4>{t('education.activity10')}</h4>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-lg-3 col-md-4 col-sm-6 mb--30">
                                <div className="activity-image-card">
                                    <div className="image-wrapper">
                                        <img src="/assets/images/activity/group.jpg" alt={t('education.activity11')} />
                                    </div>
                                    <div className="activity-title">
                                        <h4>{t('education.activity11')}</h4>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-lg-3 col-md-4 col-sm-6 mb--30">
                                <div className="activity-image-card">
                                    <div className="image-wrapper">
                                        <img src="/assets/images/activity/nature.jpg" alt={t('education.activity12')} />
                                    </div>
                                    <div className="activity-title">
                                        <h4>{t('education.activity12')}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Program Cards */}
                <div className="program-cards-area ptb--80 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb--50">
                                    <h2>{t('education.programTitle')}</h2>
                                    <p className="description">
                                        {t('education.programDesc')}
                                    </p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="row">
                            {/* อนุบาล ครึ่งวัน */}
                            <div className="col-lg-4 col-md-6 mb--30">
                                <div className="program-card">
                                    <div className="card-header">
                                        <div className="age-badge">{t('education.kindergarten')}</div>
                                        <h3>{t('education.halfDay')}</h3>
                                        <div className="duration">{t('education.durationHalf')}</div>
                                    </div>
                                    <div className="card-content">
                                        <div className="price">฿150 <span>{t('education.perPerson')}</span></div>
                                        <ul className="activities-list">
                                            <li>👨‍🏫 {t('education.introPlace')}</li>
                                            <li>🐟 {t('education.feedFish')}</li>
                                            <li>🌿 {t('education.gardenVisit')}</li>
                                            <li>🥚 {t('education.collectEgg')}</li>
                                            <li>🎨 {t('education.paint')}</li>
                                        </ul>
                                        <div className="includes">
                                            <strong>{t('education.includes')}:</strong> {t('education.includesHalf')}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* อนุบาล เต็มวัน */}
                            <div className="col-lg-4 col-md-6 mb--30">
                                <div className="program-card featured">
                                    <div className="card-header">
                                        <div className="age-badge">{t('education.kindergarten')}</div>
                                        <h3>{t('education.fullDay')}</h3>
                                        <div className="duration">{t('education.durationFull')}</div>
                                    </div>
                                    <div className="card-content">
                                        <div className="price">฿200 <span>{t('education.perPerson')}</span></div>
                                        <ul className="activities-list">
                                            <li>👨‍🏫 {t('education.introPlace')}</li>
                                            <li>🐟 {t('education.feedFish')}</li>
                                            <li>🌿 {t('education.gardenVisit')}</li>
                                            <li>🥚 {t('education.collectEgg')}</li>
                                            <li>🎨 {t('education.paintNature')}</li>
                                            <li>🍚 {t('education.lunch')}</li>
                                            <li>🏺 {t('education.paintPot')}</li>
                                            <li>🌶️ {t('education.plantPepper')}</li>
                                        </ul>
                                        <div className="includes">
                                            <strong>{t('education.includes')}:</strong> {t('education.includesFull')}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ประถม ครึ่งวัน */}
                            <div className="col-lg-4 col-md-6 mb--30">
                                <div className="program-card">
                                    <div className="card-header">
                                        <div className="age-badge">{t('education.primary')}</div>
                                        <h3>{t('education.halfDay')}</h3>
                                        <div className="duration">{t('education.durationHalf')}</div>
                                    </div>
                                    <div className="card-content">
                                        <div className="price">฿250 <span>{t('education.perPerson')}</span></div>
                                        <ul className="activities-list">
                                            <li>🎨 {t('education.paintNature')}</li>
                                            <li>🌱 {t('education.activity2')}</li>
                                            <li>🥚 {t('education.collectEgg')}</li>
                                            <li>🍎 {t('education.activity3')}</li>
                                            <li>🌾 {t('education.activity4')}</li>
                                            <li>🎮 {t('education.recreation')}</li>
                                        </ul>
                                        <div className="includes">
                                            <strong>{t('education.includes')}:</strong> {t('education.includesHalf')}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ประถม เต็มวัน */}
                            <div className="col-lg-4 col-md-6 mb--30">
                                <div className="program-card featured">
                                    <div className="card-header">
                                        <div className="age-badge">{t('education.primary')}</div>
                                        <h3>{t('education.fullDay')}</h3>
                                        <div className="duration">{t('education.durationFull')}</div>
                                    </div>
                                    <div className="card-content">
                                        <div className="price">฿350 <span>{t('education.perPerson')}</span></div>
                                        <ul className="activities-list">
                                            <li>👨‍🏫 {t('education.activity1')}</li>
                                            <li>🌱 {t('education.activity2')}</li>
                                            <li>🍎 {t('education.activity3')}</li>
                                            <li>🌾 {t('education.activity4')}</li>
                                            <li>🍽️ {t('education.activity5')}</li>
                                            <li>🍚 {t('education.lunch')}</li>
                                            <li>🎨 {t('education.paintNature')}</li>
                                            <li>♻️ {t('education.activity8')}</li>
                                            <li>🎮 {t('education.recreationWater')}</li>
                                        </ul>
                                        <div className="includes">
                                            <strong>{t('education.includes')}:</strong> {t('education.includesFull')}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* มัธยม ครึ่งวัน */}
                            <div className="col-lg-4 col-md-6 mb--30">
                                <div className="program-card">
                                    <div className="card-header">
                                        <div className="age-badge">{t('education.secondary')}</div>
                                        <h3>{t('education.halfDay')}</h3>
                                        <div className="duration">{t('education.durationHalf')}</div>
                                    </div>
                                    <div className="card-content">
                                        <div className="price">฿300 <span>{t('education.perPerson')}</span></div>
                                        <ul className="activities-list">
                                            <li>👨‍🏫 {t('education.activity1')}</li>
                                            <li>🌱 {t('education.activity2')}</li>
                                            <li>🍎 {t('education.activity3')}</li>
                                            <li>🌾 {t('education.activity4')}</li>
                                            <li>♻️ {t('education.activity8')}</li>
                                            <li>🎮 {t('education.recreation')}</li>
                                        </ul>
                                        <div className="includes">
                                            <strong>{t('education.includes')}:</strong> {t('education.includesHalf')}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* มัธยม เต็มวัน */}
                            <div className="col-lg-4 col-md-6 mb--30">
                                <div className="program-card featured">
                                    <div className="card-header">
                                        <div className="age-badge">{t('education.secondary')}</div>
                                        <h3>{t('education.fullDay')}</h3>
                                        <div className="duration">{t('education.durationFull')}</div>
                                    </div>
                                    <div className="card-content">
                                        <div className="price">฿400 <span>{t('education.perPerson')}</span></div>
                                        <ul className="activities-list">
                                            <li>👨‍🏫 {t('education.activity1')}</li>
                                            <li>🌱 {t('education.activity2')}</li>
                                            <li>🍎 {t('education.activity3')}</li>
                                            <li>🌾 {t('education.activity4')}</li>
                                            <li>🍽️ {t('education.activity5')}</li>
                                            <li>🍚 {t('education.lunch')}</li>
                                            <li>🎨 {t('education.paintNature')}</li>
                                            <li>♻️ {t('education.activity8')}</li>
                                            <li>🎮 {t('education.recreationLocal')}</li>
                                        </ul>
                                        <div className="includes">
                                            <strong>{t('education.includes')}:</strong> {t('education.includesFull')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* Benefits Section */}
                <div className="benefits-area ptb--80 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb--50">
                                    <h2>{t('education.benefitTitle')}</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-md-6">
                                <div className="benefit-item text-center">
                                    <div className="benefit-icon">
                                        <span className="icon">🌱</span>
                                    </div>
                                    <h3>{t('education.benefit1Title')}</h3>
                                    <p>{t('education.benefit1Desc')}</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="benefit-item text-center">
                                    <div className="benefit-icon">
                                        <span className="icon">🤝</span>
                                    </div>
                                    <h3>{t('education.benefit2Title')}</h3>
                                    <p>{t('education.benefit2Desc')}</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="benefit-item text-center">
                                    <div className="benefit-icon">
                                        <span className="icon">🎨</span>
                                    </div>
                                    <h3>{t('education.benefit3Title')}</h3>
                                    <p>{t('education.benefit3Desc')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Contact Section */}
                <div className="contact-area ptb--80 bg_color--2">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 offset-lg-2">
                                <div className="contact-info text-center">
                                    <h2>{t('education.contactTitle')}</h2>
                                    <p className="description">
                                        {t('education.contactDesc')}
                                    </p>
                                    <div className="contact-details">
                                        <div className="contact-item">
                                            <strong>{t('contract.phone')}:</strong> 098-237-7270
                                        </div>
                                        <div className="contact-item">
                                            <strong>Line:</strong> @852xpbpt
                                        </div>
                                        <div className="contact-item">
                                            <strong>{t('contract.facebook')}:</strong> นาจันทร์สว่างฟาร์มสเตย์ยโสธร
                                        </div>
                                    </div>
                                    <div className="cta-buttons mt--30">
                                        <a href="tel:0982377270" className="btn btn-primary mr--20">
                                            {t('education.call')}
                                        </a>
                                        <a href="https://lin.ee/htkgF3M" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                                            {t('education.lineContact')}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

            </React.Fragment>
        )
    }
}
export default withTranslation()(Education);
